import { Card } from "../../models/card";
import { StreamBed } from "../forest/streambed";
export class StoneRefining extends Card {
}
StoneRefining.displayName = "Stone Refining";
StoneRefining.artUrl = "./assets/cards/stonerefining.jpg";
StoneRefining.effect = {
    callback: () => {
        StreamBed.upgradeTier++;
    },
    description: "Improve stone refining techniques. +1 Rock from Streambeds",
    needsFeedback: true,
};
StoneRefining.destroysOnPlay = true;
